import { registerPlugin } from "@capacitor/core";

const Azureb2cPlugin = registerPlugin("Azureb2cplugin");
console.log("Plugin Register", Azureb2cPlugin);
export default Azureb2cPlugin;